import React from "react"
import { Box, CloseButton, Flex, IconButton, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { RiInformationLine } from "react-icons/ri"

const TripsMapKey: React.FC = () => {
  const { isOpen, onToggle } = useDisclosure()
  return isOpen ? (
    <Box pos="absolute" top={6} borderRadius="md" right={6} bg="white" boxShadow="md" overflow="hidden">
      <Flex justify="space-between" align="center" p={2} pl={4} bg="white">
        <Text fontWeight="600">GPS Status</Text>
        <CloseButton onClick={onToggle} size="sm" />
      </Flex>
      <Stack py={2} px={4} bg="gray.50">
        <Flex align="center">
          <Box h={2} w="20px" borderColor="gray.500" borderTop="2px solid" mt="6px" />
          <Text ml={2} fontSize="0.75rem" color="gray.700">
            Normal GPS
          </Text>
        </Flex>
        <Flex align="center">
          <Box h={2} w="20px" borderColor="gray.400" borderTop="2px dashed" mt="6px" />
          <Text ml={2} fontSize="0.75rem" color="gray.700">
            GPS unavailable
          </Text>
        </Flex>
      </Stack>
    </Box>
  ) : (
    <Box boxShadow="md" pos="absolute" top={6} right={6} bg="white" borderRadius="md" overflow="hidden">
      <IconButton
        aria-label="open map key"
        variant="ghost"
        onClick={onToggle}
        icon={<Box as={RiInformationLine} boxSize="20px" />}
      />
    </Box>
  )
}

export default TripsMapKey
